<template>
  <div>
    <div class="center_box">
      <city-top-list></city-top-list>
      <city-topsubstation></city-topsubstation>
      <div>
        <a-list :grid="{ gutter: 16, column: 4 }">
          <a-list-item v-for="(item, index) of substationData" :key="index" class="substationBox">
            <div v-if="item.title == '上庄镇'">
              <router-link target="_blank" to="/szTownship" style="color:#555555"> <a-icon type="team" />{{ item.title }}</router-link>
            </div>
            <div v-else>
              <router-link target="_blank" :to="{ path: '/countryIndex', query: { orgId: item.id } }" style="color:#555555">
                <a-icon type="team" />{{ item.title }}</router-link
              >
            </div>
          </a-list-item>
        </a-list>
      </div>
      <content-img></content-img>
      <content-top></content-top>
      <content-middle></content-middle>
      <context-middle></context-middle>
    </div>
  </div>
</template>
<script>
import CityTopBar from '../../layouts/topBox/cityBox/cityTopBar.vue'
import CityTopList from './cityBox1/cityTopList.vue'
import topBtn from '../../layouts/topBox/topBtn.vue'
import CityTopsubstation from './utils/cityTopsubstation.vue'
import ContentImg from './utils/contentImg.vue'
import ContentTop from './utils/contentTop.vue'
import ContextMiddle from '../../layouts/contextMiddle/contextMiddle.vue'
import ContentMiddle from './utils/contentMiddle.vue'
import { mapActions, mapState } from 'vuex'
import { SysOrgTreeCommon } from '@/api/main/SysOrgcountyManager'
export default {
  components: {
    topBtn,
    CityTopBar,
    CityTopList,
    CityTopsubstation,
    ContentImg,
    ContentTop,
    ContextMiddle,
    ContentMiddle
  },
  data() {
    return {
      substationData: [
        {
          name: '龙山街道',
          url: '/success'
        },
        {
          name: '天福街道',
          url: '/success'
        },
        {
          name: '环山街道',
          url: '/success'
        },
        {
          name: '文登营镇',
          url: '/success'
        },
        {
          name: '大水泊镇',
          url: '/success'
        },
        {
          name: '张家产镇',
          url: '/success'
        },
        {
          name: '高村镇',
          url: '/success'
        },
        {
          name: '侯家镇',
          url: '/success'
        },
        {
          name: '宋村镇',
          url: '/success'
        },
        {
          name: '泽头镇',
          url: '/success'
        },
        {
          name: '葛家镇',
          url: '/success'
        },
        {
          name: '米山镇',
          url: '/success'
        },
        {
          name: '界石镇',
          url: '/success'
        },
        {
          name: '埠口港管委',
          url: '/success'
        },
        {
          name: '开发区金山管委',
          url: '/success'
        },
        {
          name: '上庄镇',
          url: '/success'
        }
      ],
      imgUrl: '',
      orgId: ''
    }
  },
  created() {
    this.imgUrl = this.imageUrl
    this.BarCommon()
  },
  methods: {
    ...mapActions(['setImageUrl']),
    BarCommon() {
      this.orgId = this.$route.query.orgId
      SysOrgTreeCommon().then(res => {
        this.substationData = ''
        // eslint-disable-next-line eqeqeq
        if (res.data[1].children[1].id == this.orgId) {
          this.substationData = res.data[1].children[0].children
        }
      })
    }
  },
  mounted() {
    this.orgId = this.$route.query.orgId
  },
  computed: {
    ...mapState({
      imageUrl: state => state.app.ImageURL,
      sysType: state => state.app.sysType
    })
  }
}
</script>
<style scoped>
.ImgBox {
  padding-left: 400px;
  padding-top: 120px;
}
.ImgWords {
  font-size: 46px;
  color: #fff;
  font-weight: 800;
  text-shadow: 5px 5px 1px #ccc;
}
.center_box {
  width: 80%;
  margin: 15px auto;
}

.substationBox {
  margin-top: 10px;
  font-weight: 400;
  font-size: 16px;
  font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
}
</style>
